/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:23
 * @LastEditTime: 2020-04-17 10:14:09
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\appRouter.js
 * @Description: 
 */
'use strict';
angular.module('appRouterModule', [
    'appRouterGuardModule'
])
    
    . config(['$stateProvider', '$urlRouterProvider', function($stateProvider,
        $urlRouterProvider) {
        $stateProvider.state('front', {
            url: '/front',
            views: {
                '': {
                    template: "<div><div ui-view='head'></div><div ui-view='main'></div></div>"
                },
                'head@front': {
                    templateUrl: './header_tpl.html',
                    controller: 'HeaderController'
                }
            }
        });
        // $urlRouterProvider.otherwise('/login');
        $urlRouterProvider.otherwise('/front');
    }]);
